export default "__VITE_ASSET__Bprr7Wgd__"